import { Box, Heading, Text } from '@chakra-ui/react';

import { Card } from '~/components/card';
import { Glyph } from '~/components/glyph';

export function NoFilterResults() {
  return (
    <Card
      alignItems='center'
      borderColor='accent.sky.500'
      display='flex'
      flexDirection='column'
      padding='40px'
      textAlign='center'
    >
      <Glyph name='browser-binary-magnifying-glass-one' />
      <Box h='16px' />
      <Heading as='h2' size='h4'>
        No Results Found
      </Heading>
      <Box h='8px' />
      <Text>We could not find any results matching the provided filters.</Text>
    </Card>
  );
}
